import { connect } from "react-redux";
import Registration from "../components/Card/Registration";

function RegistrationPage({ accessToken, currentLang }) {
  return <Registration accessToken={accessToken} currentLang={currentLang} />;
}

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(RegistrationPage);
